export default __webpack_public_path__ + "static/media/Sume_Premio_Vivienda.f3e01ff4.png";